"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_NUMBER_OF_COLUMNS_VISIBLE = exports.MAX_NUMBER_OF_COLUMNS_VISIBLE = void 0;
const MIN_NUMBER_OF_COLUMNS_VISIBLE = exports.MIN_NUMBER_OF_COLUMNS_VISIBLE = 2;
const MAX_NUMBER_OF_COLUMNS_VISIBLE = exports.MAX_NUMBER_OF_COLUMNS_VISIBLE = 4;
//# sourceMappingURL=consts.js.map